module.exports = __webpack_public_path__ + "img/pr-8.4dd37c84.png";